<template>
  <el-dialog :visible.sync="visible" width="92%" :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="payable" :biz-id="form.id" perm="finance:payable" :approve-status="String(form.approveStatus || '0')" @approve="approve(form, true)" @unapprove="approve(form, false)" />
            <el-button v-if="isAuth('finance:payable:update') || isAuth('finance:payable:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:payable:delete') || isAuth('finance:payable:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : formRules" :disabled="readonly" label-width="100px">
      <el-form-item label="应付单号" prop="code"><el-input v-model="form.code" :disabled="codeReadonly || !!form.id" :placeholder="codeReadonly ? '保存时自动生成' : ''" /></el-form-item>
      <el-form-item label="业务日期" prop="bizDate">
        <el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
      </el-form-item>
      <el-form-item label="供应商" prop="supplierId">
        <el-input :value="form.partnerName" readonly placeholder="请选择供应商">
          <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="价税合计"><span>{{ lineTotal }}</span></el-form-item>
      <div v-if="!readonly" style="margin-bottom:8px"><el-button type="primary" size="small" :disabled="!form.supplierId" @click="stockPicker = true">选择入库明细</el-button></div>
      <el-table border :data="form.lines" :header-cell-style="headStyle">
        <el-table-column prop="sourceCode" label="入库单号" width="150" />
        <el-table-column prop="materialCode" label="编码" width="130" />
        <el-table-column prop="materialName" label="名称" min-width="140" />
        <el-table-column label="数量" width="140"><template slot-scope="scope"><el-input-number v-model="scope.row.quantity" :min="0" :max="Math.max(0, Number(scope.row.quantity || 0), Number(scope.row.remainQuantity || 0))" :precision="4" size="small" :disabled="readonly" /></template></el-table-column>
        <el-table-column label="单价" width="140"><template slot-scope="scope"><el-input-number v-model="scope.row.price" :min="0" :precision="4" size="small" :disabled="readonly" /></template></el-table-column>
        <el-table-column label="金额" width="120" align="right"><template slot-scope="scope">{{ money(Number(scope.row.quantity || 0) * Number(scope.row.price || 0)) }}</template></el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="60" align="center"><template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删</el-button></template></el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <SupplierSelector :visible.sync="picker" @select="onPick" />
    <FinanceStockLineSelector :visible.sync="stockPicker" :partner-id="form.supplierId" :exclude-id="form.id || ''" :ar="false" @select="onStock" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'
import FinanceStockLineSelector from '../../components/FinanceStockLineSelector.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'PayableAddOrUpdate',
  mixins: [auth],
  components: { WorkflowDocButtons, SupplierSelector, FinanceStockLineSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      picker: false,
      stockPicker: false,
      form: this.blank(),
      rules: {
        code: [{ required: true, message: '应付单号不能为空', trigger: 'blur' }],
        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '供应商不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formRules() {
      return this.codeReadonly ? { ...this.rules, code: [] } : this.rules
    },
    dialogTitle() {
      if (this.readonly) return '查看采购应付'
      return this.form.id ? '修改采购应付' : '新增采购应付'
    },
    lineTotal() {
      return (this.form.lines || []).reduce((s, l) => s + Number(l.quantity || 0) * Number(l.price || 0), 0).toFixed(2)
    }
  },
  methods: {
    blank() {
      return { code: '', bizDate: this.today(), supplierId: '', partnerName: '', totalAmount: 0, kind: 'payable', lines: [] }
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'payable' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.code = data.previewCode
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate('code'))
      }).catch(() => {})
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.picker = false
      this.stockPicker = false
      if (!id) {
        this.form = this.blank()
        this.resolveCode()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/arap/info', { params: { kind: 'payable', id } }).then(res => {
        const data = res.data || {}
        this.form = Object.assign({ kind: 'payable', lines: [] }, data, {
          supplierId: data.supplierId || data.partnerId || ''
        })
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (!this.assertCanEditDoc('delete')) return
      this.$confirm('确定删除该应付单?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/arap/delete', { kind: 'payable', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    onPick(row) { this.form.supplierId = row.supplierId; this.form.partnerName = row.supplierName; this.form.lines = []; this.$refs.dataForm && this.$refs.dataForm.validateField('supplierId') },
    onStock(rows) { rows.forEach(row => this.form.lines.push(row)) },
    approve(row, pass) {
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(pass ? '/finance/arap/approve' : '/finance/arap/unapprove', { kind: 'payable', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          this.$set(this.form, 'approveStatus', pass ? '2' : '0')
          this.readonly = true
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.lines.length) { this.$message.warning('请选择入库明细'); return }
        if (this.form.lines.some(line => Number(line.quantity || 0) <= 0 || Number(line.quantity || 0) > Number(line.remainQuantity || 0))) {
          this.$message.warning('挂账数量须大于 0 且不能超过可挂账数量')
          return
        }
        this.form.totalAmount = Number(this.lineTotal)
        request.post('/finance/arap/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
